import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch, AppThunk } from "@/app/store";
import { CampaignStatusMetadata } from "@/modules/administration/features/Stochastic/CampaignStatus/api/fetchCampaignStatusMetadata/types";
import { algoliasearch } from "algoliasearch";
import { fetchCampaignStatusMetadataAlgoliaConfig } from "@/modules/administration/features/Stochastic/CampaignStatus/api/fetchCampaignStatusMetadataAlgoliaConfig/fetchCampaignStatusMetadataAlgoliaConfigApi";

interface CampaignStatusMetadataState {
  metadata: CampaignStatusMetadata | null;
  loading: boolean;
  error: string | null;
}

const initialState: CampaignStatusMetadataState = {
  metadata: null,
  loading: false,
  error: null,
};

const campaignStatusMetadataSlice = createSlice({
  name: "campaignStatusMetadata",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setMetadata: (state, action: PayloadAction<CampaignStatusMetadata>) => {
      state.metadata = action.payload;
    },
  },
});

export const { setLoading, setError, setMetadata } =
  campaignStatusMetadataSlice.actions;

export const fetchCampaignStatusMetadataAction =
  (): AppThunk => async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    dispatch(setError(null));
    try {
      const config = await fetchCampaignStatusMetadataAlgoliaConfig();
      const client = algoliasearch(config.applicationId, config.securedApiKey);

      const result = await client.getObject({
        indexName: config.indices.campaignStatusMetadata,
        objectID: config.objectId,
      });

      console.log(result);

      const { ...metadataFields } = result as Record<string, unknown>;

      dispatch(
        setMetadata(metadataFields as unknown as CampaignStatusMetadata),
      );
    } catch (error) {
      if (error instanceof Error) {
        dispatch(setError(error.message));
      } else {
        dispatch(
          setError("Failed to fetch campaign status metadata from Algolia"),
        );
      }
    } finally {
      dispatch(setLoading(false));
    }
  };

export default campaignStatusMetadataSlice.reducer;
